import { HardwareType } from './types/types'

export const getHardwareTypeIconPath = (type: HardwareType | undefined, includeUnknownIcon?: boolean): string => {
  return type === 'ROBOT' ? 'assets/tessa-dark.svg' : type === 'VOICE_ASSISTANT' ? 'assets/voice-assistant.svg' : includeUnknownIcon ? 'assets/unknown.svg' : 'empty'
}

export const getHardwareTypeBlockedIconPath = (type: HardwareType | undefined): string => {
  return type === 'ROBOT' ? 'assets/block.svg' : type === 'VOICE_ASSISTANT' ? 'assets/voice-assistant-blocked.svg' : 'empty'
}
